/* eslint-disable no-console */
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, createStore, compose } from 'redux';

import { showSnackbar } from 'modules/App/store/actions';

import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware({
  onError: ({ message }, { sagaStack }) => {
    if (message.match('client') && message.match('offline'))
      store.dispatch(
        showSnackbar(
          'You are offline. Reconnect to the internet and refresh the page.',
        ),
      );
    else {
      console.error(message);
      console.error(sagaStack);
    }
  },
});

const middlewares = [sagaMiddleware];

const store = createStore(
  rootReducer(),
  process.env.NODE_ENV === 'development'
    ? composeEnhancers(applyMiddleware(...middlewares))
    : applyMiddleware(...middlewares),
);

sagaMiddleware.run(rootSaga);

export { store };
